var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33108 6.79943C9.73953 5.04058 10.6292 3.37081 12 2C13.3704 3.37041 14.2599 5.03962 14.6685 6.79792C13.5859 7.69506 12.6838 8.7792 11.9989 9.98691C11.3144 8.77988 10.4129 7.69628 9.33108 6.79943Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C16.4772 12 12 16.4772 12 22C17.5228 22 22 17.5228 22 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C7.52285 12 12 16.4772 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.978 16.2787C12.2717 11.6243 9.26149 7.25348 4.58346 6C4.15081 7.61467 4.13914 9.24297 4.48117 10.7683C7.68603 11.4731 10.3897 13.5147 11.978 16.2787Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5165 10.7689C16.3113 11.4744 13.6076 13.5171 12.02 16.2822C11.7245 11.6266 14.7351 7.25379 19.4143 6C19.847 7.61485 19.8586 9.24334 19.5165 10.7689Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHop);
export default __webpack_public_path__ + "static/media/hop.7f260829e23df200e8971565ef3a0fcf.svg";
export { ForwardRef as ReactComponent };